import React from 'react';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';

const AlertDialog = (props) => {
    const { open, noClick, yesClick, title, text } = props;


    return (
        <div>
            <Dialog
                open={open}
                onClose={noClick}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        {text}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={noClick} color="primary">
                        Close
                    </Button>
                    {yesClick &&
                        <Button onClick={yesClick} color="primary" autoFocus>
                            Yes
                        </Button>
                    }
                </DialogActions>
            </Dialog>
        </div>
    );
};

export default AlertDialog;